import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import useCCWeeklyReport from './hooks/useCCWeeklyReport';
import CCWeeklyReportSearchBar from './components/CCWeeklyReportSearchBar';
import { getCCWeeklyReportTableRows } from './helpers/getCCWeeklyReportTableRows';
import { getCCWeeklyTableColumns } from './helpers/getCCWeeklyReportTableColumns';

const CCWeeklyReport = () => {
	const hook = useCCWeeklyReport();

	return (
		<>
			{hook.isLoading && <Loading />}
			<WrapperWithScroll>
				<CCWeeklyReportSearchBar formik={hook.formik} />
				{hook.data && (
					<>
						<Table
							className='styled-table'
							raws={getCCWeeklyReportTableRows(hook.data)}
							headers={getCCWeeklyTableColumns()}
						/>
					</>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default CCWeeklyReport;
